import { ShowcaseProject } from "./showcase-project-types";

export class ShowcaseProjectState {
	public project: ShowcaseProject | undefined;

	public user: any;

	public isUserAuthor: boolean = false;
}